import React from "react";

import {MuiIcon, MuiIconExternalProps} from './MuiIcon';

export const LeftPanelClose = React.forwardRef<HTMLElement, MuiIconExternalProps>(
    (props: MuiIconExternalProps, ref) => {
        return (
            <MuiIcon{...props}
                    ref={ref}
            >{'\uf717'}</MuiIcon>
        );
    }
)
